import styled from "styled-components";

export const Main = styled.div`
  height: calc(100% - 80px);

  flex-grow: 1;
`;
